import React, { useState, useRef } from 'react';

import { images } from '../../Constants';
import { AppWrap, MotionWrap } from '../../wrapper';
import { client } from '../../client';
import './footer.scss';
import emailjs from 'emailjs-com';

const Footer = () => {
  const [formData, setFormData] = useState({ name: '', email: '', message: '' });
  const [isFormSubmitted, setIsFormSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const form = useRef();
  const { username, useremail, usermessage } = formData;

  const handleChangeName = (e) => {
    const {value } = e.target;
    setFormData({ ...formData, name: value});
  };
  const handleChangeEmail = (e) => {
    const { value } = e.target;
    setFormData({ ...formData, email: value});
  };
  const handleChangeMessage = (e) => {
    const { value } = e.target;
    setFormData({ ...formData, message: value});
  };
 
 
  const sendEmail = (e) => {
    handleSubmit();
    e.preventDefault();
     setLoading(true);
   emailjs.sendForm('service_bhyxh28', 'template_jcv2a0x', form.current, 'oYd68k2oWqxSXbADH')
      .then((result) => {
          console.log(result.text);
      }, (error) => {
          console.log(error.text);
      });   
    
  };

  const handleSubmit = (e) => {

    const contact = {
      _type: 'contact',
      name: formData.name,
      email: formData.email,
      message: formData.message,
    };

    client.create(contact)
      .then(() => {
        setLoading(false);
        setIsFormSubmitted(true);
      })
      .catch((err) => console.log(err));
  };

  return (
    <>
      <h2 className="head-text">CONTACT</h2>

      <div className="app__footer-cards">
        <div className="app__footer-card " style={{backgroundColor:'#FFF2CC'}}>
          <img src={images.email} alt="email" />
          <a href="mailto:sushmanag73@gmail.com" className="p-text">sushmanag73@gmail.com</a>
        </div>
        <div className="app__footer-card">
          <img src={images.mobile} alt="phone" />
          <a href="tel:+91 9131155328" className="p-text">+91 9131155328</a>
        </div>
      </div>
      {!isFormSubmitted ? (
        <div className="app__footer-form app__flex">
          <form ref={form} onSubmit={sendEmail} style={{width:'60%'}}>
          <div className="app__flex">
            <input className="p-text" type="text" placeholder="Your Name" name="user_name" value={username} onChange={handleChangeName} />
          </div>
          <div className="app__flex">
            <input className="p-text" type="email" placeholder="Your Email" name="user_email" value={useremail} onChange={handleChangeEmail} />
          </div>
          <div>
            <textarea
              className="p-text"
              placeholder="Your Message"
              value={usermessage}
              name="message"
              onChange={handleChangeMessage}
            />
          </div>

          <button className="app__button" onClick={sendEmail}>Send</button>
          </form>
          </div>

      ) : (
        <div>
          <h3 className="head-text">
            Thank you for getting in touch!
          </h3>
        </div>
      )}
    </>
  );
};

export default AppWrap(
  MotionWrap(Footer, 'app__footer'),
  'contact',
  'app__whitebg',
);
